import { Theme } from '@material-ui/core/styles'

export const spacingInPixels = (theme: Theme, value: number): string => `${theme.spacing(value)}px`

export default spacingInPixels
